import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import { useSelector } from "react-redux";


const CompleteSolution = ({ open, setOpen, question = {} }) => {
  const handleClose = () => {
    setOpen(false);
  };

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Course || {},
  }));

  return (
    <Dialog fullWidth maxWidth={"xs"} open={open} onClose={handleClose}>
      <DialogTitle>
        {Translation?.CompleteSolution}
        <IconButton onClick={() => handleClose()}>
          {" "}
          <PrimaryIcon
            icon={CloseIcon}
            color="white"
            height="14px"
            width="14px"
          />{" "}
        </IconButton>{" "}
      </DialogTitle>
      <DialogContent>
        <Typography fontWeight={500}>{Translation?.CorrectAnswer}:-</Typography>
        <Typography color="secondary.light">
          {question?.Solution}
        </Typography>

        {/* <Typography color="secondary.light">
          H0: Coaching does not improve score; Ha: Coaching improves score
        </Typography>
        <Typography fontWeight={500}>Explanation:-</Typography>
        <Typography color="secondary.light">
          We are given the average score of verbal reasoning section of GRE
          exam.
        </Typography>
        <Typography color="secondary.light">
          By default, we would assume that a student’s score would conform to
          given distribution, irrespective of whether are enrolled in coaching
          or not.
        </Typography>
        <Typography color="secondary.light">
          However, there is a coaching center that claims to improve the scores.
        </Typography> */}
      </DialogContent>
      <DialogActions align="center">
        {/* <Button type="submit" variant="contained">
          Access Hint
        </Button> */}
        <Button
          onClick={() => handleClose()}
          variant="outlined"
          color="secondary"
        >
          {Translation?.Okay}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompleteSolution;
